import React from 'react';
import { CloseButtonStyle } from './CloseButton.styles';
import { X } from 'lucide-react';

interface CloseButtonProps {
  onClick: () => void;
}

export const CloseButton: React.FC<CloseButtonProps> = ({ onClick }) => (
  <CloseButtonStyle
    onClick={onClick}
    aria-label="Close">
    <X size={18} strokeWidth={2.5} />
  </CloseButtonStyle>
);